var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_magnifier"},[_c('img',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height},on:{"mouseover":_vm.handOver,"mousemove":_vm.handMove,"mouseout":_vm.handOut}})])
}
var staticRenderFns = []

export { render, staticRenderFns }